import { render, staticRenderFns } from "./TransactionPlans.vue?vue&type=template&id=a9f7afcc&scoped=true&"
import script from "./TransactionPlans.vue?vue&type=script&lang=ts&"
export * from "./TransactionPlans.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionPlans.vue?vue&type=style&index=0&id=a9f7afcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f7afcc",
  null
  
)

export default component.exports